import {
  ConfigService,
  LegendConfigProtocol
} from '../../';

export class LegendConfig implements LegendConfigProtocol {
	public color = '#F00';

	constructor(private configService: ConfigService) {}

	update(config: any) {
		if (typeof config.legend === 'object') {
			this.color = this.configService.getColor(config.legend.color, this.color);
		}

		this.configService.legend.next(this);
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/legendConfig.ts